<div class="wrapper mt-[20px]">
  <div class="workflow-list">
    @if (updates?.length) {
      @for (u of updates; track u.id) {
        <div class="time-block" [attr.data-testid]="'update-' + u.type">
          <div class="label-container flex flex-row gap-[12px] mb-[7px]">
            <div class="icon-container flex justify-center items-center"
              [ngClass]="{ correct: icon(u) === 'ok', up: icon(u) === 'up', down: icon(u) === 'down', closed: icon(u) === 'closed', conv: icon(u) === 'conv', reject: icon(u) === 'rej', edit: icon(u) === 'edit' }">
              <span class="glyph">{{ iconGlyph(u) }}</span>
            </div>
            <div class="timeline-label">{{ label(u) }}</div>
          </div>
          <div class="details">
            <div class="user flex flex-row gap-[8px] mb-[16px]">
              <div class="user-avatar">{{ initial(u) }}</div>
              <div class="user-details flex flex-col">
                <div class="user-name">{{ actorName(u) }}</div>
                @if (u.createdBy?.email) {
                  <div class="user-email">{{ u.createdBy.email }}</div>
                }
              </div>
            </div>
            @if (hasScore(u)) {
              <div class="mt-[20px]" data-testid="score-line">
                <div class="timeline-sub-heading">Score:</div>
                <div class="score-row flex flex-row items-center gap-[8px]">
                  @if (u.type === 'score_changed') {
                    <app-risk-score-chip [score]="u.data.score_before" />
                    <span class="arrow">→</span>
                  }
                  <app-risk-score-chip [score]="u.data.score_after" [trend]="u.type === 'score_changed' ? u.data.trend : undefined" />
                  <span class="user-email">Probability {{ u.data.probability_before !== undefined && u.data.probability_before !== u.data.probability_after ? u.data.probability_before + ' → ' : '' }}{{ u.data.probability_after }} · Impact {{ u.data.impact_before !== undefined && u.data.impact_before !== u.data.impact_after ? u.data.impact_before + ' → ' : '' }}{{ u.data.impact_after }}</span>
                </div>
              </div>
            }
            @if (u.data?.comment) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">Comment:</div>
                <div class="comment">
                  @if (shouldTruncate(u.data.comment)) {
                    <span>{{ isExpanded(u.id) ? u.data.comment : truncated(u.data.comment) }}</span>
                    <span (click)="toggle(u.id)" (keyup.enter)="toggle(u.id)" tabindex="0" role="button" class="show-more-less-link cursor-pointer">{{ isExpanded(u.id) ? ' Show less' : ' Show more' }}</span>
                  } @else {
                    <span>{{ u.data.comment }}</span>
                  }
                </div>
              </div>
            }
            @if (ownerLabel(u); as ownerName) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">Owner:</div>
                <div class="user flex flex-row items-center gap-[8px]">
                  @if (u.data?.owner_name) {
                    <div class="avatar">{{ ownerName.charAt(0) }}</div>
                  }
                  <div class="avatar-name">{{ ownerName }}</div>
                </div>
              </div>
            }
            @if (u.type === 'converted' && u.data?.issue_title) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">Issue:</div>
                <div class="comment">{{ u.data.issue_title }}</div>
              </div>
            }
            @if (changes(u).length) {
              <div class="mt-[20px]">
                <div class="timeline-sub-heading">Changes:</div>
                @for (c of changes(u); track c.field) {
                  <div class="comment"><span class="capitalize">{{ c.field }}</span>: {{ c.before ?? '—' }} → {{ c.after ?? '—' }}</div>
                }
              </div>
            }
            @if (u.attachments?.length) {
              <div class="my-[20px]">
                <div class="pictures-row flex flex-wrap gap-[20px]">
                  @for (attachment of u.attachments; track attachment.id) {
                    <div class="picture-block">
                      @if (attachment?.thumb_url) {
                        <app-image (click)="appService.openCarousel($event, u.attachments, attachment, false)" [url]="attachment.thumb_url" class="each-picture" />
                      } @else {
                        <div (click)="appService.openCarousel($event, u.attachments, attachment, false)" (keyup.enter)="appService.openCarousel($event, u.attachments, attachment, false)" tabindex="0" role="button" class="each-document">
                          <span class="file-title">{{ attachment?.original_name || 'Attachment' }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
            <div class="created-at-container mt-[8px] h-[47px]">
              <div class="created-at flex flex-row justify-start items-center gap-[8px]">
                <div>{{ formatInProjectTimezone(u.created_at, 'MMMM D, YYYY') }}</div>
                <div>&#x25CF;</div>
                <div>{{ formatInProjectTimezone(u.created_at, 'hh:mm A') }}</div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (updates.length < total) {
        <button type="button" class="show-more-less-link load-more" (click)="loadMore.emit()" data-testid="updates-load-more">Load more</button>
      }
    } @else {
      <div class="no-data flex flex-col justify-center items-center gap-[20px]">
        <div class="no-data-text text-center text-type-14">No updates yet.</div>
      </div>
    }
  </div>
</div>
